import $ from "jquery";
import { HtmlFix, HtmlScroll } from "./common.js";

function HeaderMenu() {
  var menu = $(".js-header-menu"),
    trigger = $(".js-header-menu-trigger"),
    overlay = $(".js-header-overlay"),
    windowWidth = $(window).width(),
    modalClick;

  //リサイズ時の処理
  $(window).on("resize", function () {
    windowWidth = $(window).width();
    if (windowWidth < 768) {
      menuClose();
      //開いているモーダルがある時は除外
      if (!$(".js-modal").hasClass("is-open")) {
        $("html").removeClass("is-fixed");
      }
      overlayOff();
    } else {
      //キー移動制御を非活性化
      menu.off("keydown");
      modalClick = null;
    }
  });

  //トリガーでメニュー開く
  $(".js-header-menu-trigger").on("click", function () {
    var trigger = $(this),
      target = $(this).attr("data-target"),
      targetMenu = $(target);

    if ($(this).hasClass("is-open")) {
      menuClose();
      HtmlScroll();
      overlayOff();
    } else {
      if (windowWidth >= 768) {
        menuClose();
      }
      menuOpen(trigger, targetMenu);
    }
  });

  //バツボタンで閉じる
  $(".js-header-menu-close").on("click", function () {
    menuClose();
    overlayOff();
    HtmlScroll();
  });

  //オーバーレイクリックで閉じる
  overlay.on("click", function () {
    menuClose();
    overlayOff();
    HtmlScroll();
  });

  //メニュー開く処理
  function menuOpen(trigger, targetMenu) {
    trigger.addClass("is-open");
    overlay.fadeIn();
    if (windowWidth >= 768) {
      targetMenu.addClass("is-open").slideDown();
    } else {
      HtmlFix();
      targetMenu.show().scrollTop(0).addClass("is-open");
    }

    // aria属性
    trigger.attr("aria-expanded", true);

    if (windowWidth < 768) {
      modalClick = trigger;

      //キー移動制御
      var focusElements = targetMenu.find(":input:visible, button:visible, a:visible");
      var firstFocusElement = focusElements[0];
      var lastFocusElement = focusElements[focusElements.length - 1];
      var updateLastFocusElement;

      //最初のフォーカス要素にフォーカスを当てる
      $(firstFocusElement).trigger("focus");
      targetMenu.on("keydown", function (e) {
        if (e.code === "Tab") {
          if (e.shiftKey) {
            // Shift + Tab が押された時
            if ($(document.activeElement).is(firstFocusElement)) {
              e.preventDefault();
              $(lastFocusElement).trigger("focus");
            }
          } else {
            // Tab が押された時
            if ($(document.activeElement).is(lastFocusElement)) {
              //要素を取り直す
              focusElements = targetMenu.find(":input:visible, button:visible, a:visible");
              updateLastFocusElement = focusElements[focusElements.length - 1];

              //再取得した要素が再取得前の最後の要素と一致する時のみ
              if (lastFocusElement === updateLastFocusElement) {
                e.preventDefault();
                $(firstFocusElement).trigger("focus");
              }
            }
            //再取得したフォーカス可能な最後の要素
            if ($(document.activeElement).is(updateLastFocusElement)) {
              e.preventDefault();
              $(firstFocusElement).trigger("focus");
            }
          }
        }
      });
    }
  }

  //メニュー閉じる処理
  function menuClose() {
    trigger.removeClass("is-open");
    if (windowWidth >= 768) {
      menu.removeClass("is-open").slideUp(function () {
        $(this).removeAttr("style");
      });
    } else {
      menu
        .stop()
        .removeClass("is-open")
        .delay(300)
        .queue(function () {
          $(this).hide().dequeue();
        });
    }

    if (modalClick) {
      modalClick.trigger("focus");
    }

    // aria属性
    trigger.attr("aria-expanded", false);
  }

  //オーバーレイオフ
  function overlayOff() {
    overlay.fadeOut();
  }
}

export { HeaderMenu };
